/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBoolean } from '../../../../Fct/generics/FctParams';
import cometList from '../../../../Fct/plugins/compoundv3/helpers/cometList.json';
export var IsBorrowCollateralized = createPlugin({
    protocol: 'COMPOUND_V3',
    type: 'GETTER',
    method: 'isBorrowCollateralized',
    description: 'Function returns the current balance of a collateral asset for a specified account in the protocol.',
    supportedContracts: cometList,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                account: new FctAddress({}),
            },
        },
        output: { hasEnoughLiquidity: new FctBoolean({ innerIndex: 0 }) },
    }); },
});
